import { Inject, Injectable, Optional } from '@angular/core';
import { DateTime } from 'ts-luxon';

import { ILogger } from './ilogger';
import { LoggerService } from './logger.service';
import { LogLevel } from './models';

@Injectable()
export class Logger extends ILogger {
	constructor(
		private loggerService: LoggerService,
		@Optional() @Inject(String) scope: string
	) {
		super();
		this.scope = scope || '';
	}

	public log(level: LogLevel, eventId: string, message: string, args?: unknown): void {
		// Attaching the time to the LogEntry as early as possible. If done as
		// the log entry is written, it could be skewed by the rxjs obs being backed up.
		const timestamp = DateTime.now().toFormat('yyyy:MM:dd HH:mm:ss.SSS');
		this.loggerService.log(timestamp, this.scope, level, eventId, message, args);
	}

	public createScopedLogger(@Optional() scope: string): ILogger {
		const newLogger = new Logger(this.loggerService, scope);
		return newLogger;
	}
}
